module.exports = __webpack_public_path__ + "img/Icon - Skipped Question.35404c8b.svg";